export enum EnumPath {
    Home = 'home',
    SelectCountry = 'Select-country',
    SelectStreamingServices = 'Select-streaming-services',
    KindOfCinema = 'Kind-of-cinema',
    YourMood = 'Your-mood',
    MySpecification = 'My-specification',
    MoviesResults = 'Movies-results',
    MovieDetails = 'Moviie-details',
}